/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSessionDailySummary,
    MelcoModelsSessionDailySummaryFromJSON,
    MelcoModelsSessionDailySummaryFromJSONTyped,
    MelcoModelsSessionDailySummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSessionDailySummary
 */
export interface MelcoModelsGenericList1MelcoModelsSessionDailySummary {
    /**
     * 
     * @type {Array<MelcoModelsSessionDailySummary>}
     * @memberof MelcoModelsGenericList1MelcoModelsSessionDailySummary
     */
    list: Array<MelcoModelsSessionDailySummary>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSessionDailySummary
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSessionDailySummary
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSessionDailySummaryFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSessionDailySummary {
    return MelcoModelsGenericList1MelcoModelsSessionDailySummaryFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSessionDailySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSessionDailySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSessionDailySummaryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSessionDailySummaryToJSON(value?: MelcoModelsGenericList1MelcoModelsSessionDailySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSessionDailySummaryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


